import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import User from "../../components/user/Profile";
import { userService, royaltiesService } from "../../services";
import Spinner from "../../components/UI/Spinner"
import ErrorModal from "../../components/UI/Error"

const ArtistProfilePage = () => {
  const { id } = useParams();
  const [artist, setArtist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchArtist = async () => {
      try {
        setError(false)
        const response=await userService.myProfile()
        setArtist(response);
      } catch (error) {
        setError(true)
        console.error("Error fetching artist:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArtist();
  }, [id]);

  if (loading) return <div className="grid place-content-center h-[60vh]"><Spinner/></div>;
  if (error || !artist) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={"Error Getting Details"} message={"There is error while trying to fetch the details. Please check your internet contivities and refresh this page to try again"} />;
  return (
    <User user={artist} socialHeading={true} editProfile={`/user/my-profile/edit/${artist._id}`}>
      <div>
      <h1 className="text-xl font-semibold mb-3 text-yellow-400">SubScription Info</h1>
        <h1>Loading...</h1>
      </div>
    </User>
  );
};

export default ArtistProfilePage;
